import { Settings as SettingsInterface } from '@wam/shared';
import settings from '../../assets/configuration.json';

export function getSettings(): SettingsInterface {
  return settings as SettingsInterface;
}
